<!-- <p-progressSpinner *ngIf="!initialized" [style]="{width: '15px', height: '15px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner> -->
<div [fxHide]="!initialized" class="container" fxLayout="column">
    <!-- <span fxFlex="0 0 auto" class="center">{{title}}</span> -->
    <p-selectButton fxFlex="0 0 auto" [options]="historicalModes" [(ngModel)]="selectedHistoricalMode"
        (onChange)="onHistoricalModeSelected()"></p-selectButton>
    <!-- <button (click)="togglePopup()">Popup</button> -->
    <div fxLayout="column" class="historicalchartwrapper liquitics-box">
        <ng-container *ngTemplateOutlet="chart"></ng-container>

        <!-- <div fxFlex="1 1 auto" [id]="'historicalchartdiv'+index" class="chartdiv"></div> -->
    </div>
</div>
<p-dialog header="Historical" [(visible)]="isPopup" modal="modal" class="historical-popup">
    <!-- <div fxFlex="1 1 auto" [id]="'popuphistoricalchartdiv'+index" class=""></div> -->
    <div>
        <ng-container *ngTemplateOutlet="chart"></ng-container>
    </div>
</p-dialog>

<ng-template #chart>
    <div fxFlex="1 1 auto" [id]="'historicalchartdiv'+index" class="chartdiv"></div>
</ng-template>